import { useState } from "react";
import { AudienceDestinationProps } from "./AudienceDestination.types";

const useAudienceDestination = (props: AudienceDestinationProps) => {
  const [showSourceTextbox, setShowSourceTextbox] = useState(false);

  return {
    ...props,
    showSourceTextbox,
    setShowSourceTextbox,
  };
};

export default useAudienceDestination;
